import React from 'react';
import PropTypes from 'prop-types';

import {Typography, Stack} from 'views/components';
import {AccessTime as AccessTimeIcon} from 'views/icons';
import {Translate, translate, Map} from 'views/module';

import TimelineCard from './TimelineCard';
import moment from 'moment';

const ShiftClockedIn = (props) => {
  const {clockIn, caregiverData} = props;

  const timeString = moment(clockIn.createdAt).format('LLL');

  const actualClockinTimeFormatted = clockIn.data.actualClockinTimeFormatted;
  const suggestedClockinTimeFormatted = clockIn.data.suggestedClockinTimeFormatted;

  // // Format data if present
  const actualClockinTime = actualClockinTimeFormatted ? moment(actualClockinTimeFormatted).format('h:mm A') : null;
  const suggestedClockinTime = suggestedClockinTimeFormatted ? moment(suggestedClockinTimeFormatted).format('h:mm A') : null;
  const location = clockIn.data.location;
  const notes = clockIn.data.additionalNotes || translate('eventList.EventTimelineSection.ShiftClockedIn.NoNotes');

  return (
    <TimelineCard
      timeString={timeString}
      icon={AccessTimeIcon}
      iconColor="#7b1fa2"
      timeBg="#e0e0e0"
      title=
        {
          <Typography variant="h5" fontWeight={700} fontSize={'22px'} textAlign="left">
            <Translate expression='eventList.EventTimelineSection.ShiftClockedIn.Title' />
          </Typography>
        }
    >
      <Stack spacing={1}>
        <Typography fontWeight={700} color="text.secondary" fontSize={'16px'} textAlign="left">
          <Translate
            expression='eventList.EventTimelineSection.ShiftClockedIn.Description'
            substitute={{caregiverName: caregiverData.caregiverDetail.caregiverName}}
          />
        </Typography>

        {
          actualClockinTimeFormatted && suggestedClockinTimeFormatted &&
          (
            <Stack spacing={1}>
              {/* Clock out timings */}
              <Stack direction='row' spacing={1} alignItems="center">
                <Typography
                  fontWeight={700}
                  fontSize={{xs: '13px', sm: '14px', md: '15px', lg: '16px'}}
                  minWidth={{xs: 120, sm: 140, md: 180}}
                  textAlign="left"
                >
                  <Translate expression='eventList.EventTimelineSection.ShiftClockedIn.ClockinTime'/>
                </Typography>
                <Typography
                  fontWeight={700}
                  color="text.secondary"
                  fontSize={{xs: '13px', sm: '14px', md: '15px', lg: '16px'}}
                  textAlign="left"
                >
                  {actualClockinTime}
                </Typography>
              </Stack>
              <Stack direction='row' spacing={1} alignItems="center">
                <Typography
                  fontWeight={700}
                  fontSize={{xs: '13px', sm: '14px', md: '15px', lg: '16px'}}
                  minWidth={{xs: 120, sm: 140, md: 180}}
                  textAlign="left"
                >
                  <Translate expression='eventList.EventTimelineSection.ShiftClockedIn.EditedClockinTime'/>
                </Typography>
                <Typography
                  fontWeight={700}
                  color="text.secondary"
                  fontSize={{xs: '13px', sm: '14px', md: '15px', lg: '16px'}}
                  textAlign="left"
                >
                  {suggestedClockinTime}
                </Typography>
              </Stack>
              {/* Notes */}
              <Stack direction='row' spacing={1} alignItems="center">
                <Typography
                  fontWeight={700}
                  fontSize={{xs: '13px', sm: '14px', md: '15px', lg: '16px'}}
                  minWidth={{xs: 120, sm: 140, md: 180}}
                  textAlign="left"
                >
                  <Translate expression='eventList.EventTimelineSection.ShiftClockedIn.Notes'/>
                </Typography>
                <Typography
                  color="text.secondary"
                  fontSize={{xs: '13px', sm: '14px', md: '15px', lg: '16px'}}
                  textAlign="left"
                >
                  {notes}
                </Typography>
              </Stack>
              {/* Location Data */}
              <Stack direction='row' spacing={1} alignItems="center">
                <Typography
                  fontWeight={700}
                  fontSize={{xs: '13px', sm: '14px', md: '15px', lg: '16px'}}
                  minWidth={{xs: 120, sm: 140, md: 180}}
                  textAlign="left"
                >
                  <Translate expression='eventList.EventTimelineSection.ShiftClockedIn.Location'/>
                </Typography>
              </Stack>
              {
                location ?
                <Map height={'200px'} width={'100%'} coordinates={[location.latitude, location.longitude]} /> :
                <Typography
                  color="text.secondary"
                  fontSize={{xs: '13px', sm: '14px', md: '15px', lg: '16px'}}
                  textAlign="left"
                >
                  <Translate expression='eventList.EventTimelineSection.ShiftClockedIn.NoLocation'/>
                </Typography>
              }
            </Stack>
          )
        }
      </Stack>
    </TimelineCard>
  );
};

ShiftClockedIn.propTypes = {
  clockIn: PropTypes.shape({
    createdAt: PropTypes.string.isRequired,
    data: PropTypes.shape({
      actualClockinTimeFormatted: PropTypes.string,
      suggestedClockinTimeFormatted: PropTypes.string,
      location: PropTypes.object,
      additionalNotes: PropTypes.string,
    }),
  }).isRequired,
  caregiverData: PropTypes.shape({
    caregiverDetail: PropTypes.shape({
      caregiverName: PropTypes.string,
    }),
  }).isRequired,
};

export default ShiftClockedIn;
